export default __webpack_public_path__ + "static/media/cancel.be7982ef.svg";